import Tracker from '@telus/contentful-tracking'
import { createClient } from 'contentful'
import config from '../config'

const APPLICATION_NAME = 'UDEPurchase-uiCart'

const { personalizationApi } = config
const tracker = new Tracker(personalizationApi?.space, APPLICATION_NAME)
const responseLogger = (response) => tracker.sdkHandler(response?.data)

const createPersonalizationClient = (cookies) => {
  const filteredCookies = {
    'AMCV_67A50FC0539F0BBD0A490D45%40AdobeOrg': cookies['AMCV_67A50FC0539F0BBD0A490D45%40AdobeOrg'],
    referer: cookies.referer,
    agent: cookies.agent,
    kndctrIdentity: cookies.kndctr_67A50FC0539F0BBD0A490D45_AdobeOrg_identity,
    kndctrCluster: cookies.kndctr_67A50FC0539F0BBD0A490D45_AdobeOrg_cluster,
    OptanonConsent: cookies.OptanonConsent,
    uuid: cookies.uuid || ''
  }

  const stringifiedFilteredCookies = JSON.stringify(filteredCookies)
  const client = createClient({
    ...personalizationApi,
    resolveLinks: true,
    responseLogger,
    headers: {
      cookies: stringifiedFilteredCookies
    }
  })

  return client
}

export default createPersonalizationClient
